import React, { Component } from "react";

class Failed extends Component {   
    render() {
        return (
            <div className="overLay">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-10 col-xl-8">
                            <div className="card mt-7">
                                <div className="card-body text-center">
                                    <div className="row justify-content-center">
                                        <div className="col-12 col-md-10 col-xl-8 ">
                                            <h2 className="text-muted large-font mb-4">
                                                <b>Unfortunately, you did not pass for the following reason:</b>
                                            </h2>    
                                            <div className="qsnlistWrapper">
                                                <ul className="qsnlist">
                                                    {this.props.questions && this.props.questions.map( (e, k) => <li key={e.id} className="text-muted">{k+1}. INCORRECT: {e.question}</li>)}
                                                </ul>
                                            </div>                                          
                                            
                                            <p className="text-muted mt-4">
                                                <span className="highlight">You have no more attempts
                                                remaining.</span> Unfortunately, you
                                                are required to pass the
                                                proficiency test in order to
                                                complete your application, so we
                                                will not be able to accept you
                                                as a writer at this time.
                                            </p>

                                            <a
                                                href="/account"
                                                className="btn btn-primary mt-4"
                                            >
                                                Go Back to Dashboard
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default Failed;



// WEBPACK FOOTER //
// ./src/components/writer/quiz/Failed.js